export default __webpack_public_path__ + "static/media/active-hbA1c.608fabe6.svg";